const MODAL_FOOTER_CONFIG = {
  btnList: [
    { title: '确定', type: 'primary', cb: 'exitLogin' },
    { title: '取消', cb: 'cancel' }
  ]
}

module.exports = {
  MODAL_FOOTER_CONFIG
}